export enum SortingOrderEnum {
  ASC = 'ASC',
  DESC = 'DESC',
}
